export enum StaffType {
  Teacher = 1,
  SupportStaff = 2,
}
